// Values taken from sass/1.settings/$breakpoints.scss
// Because @mixin media is more often used then @mixin media-max so these breakpoints are taken as max-width
export const LARGE_MAX = 2199;
export const MEDIUM_MAX = 1439;
export const TABLET_MAX = 1024;
export const SMALL_MAX = 767;
export const MOBILE_MAX = 640;
export const HEADER_BREAK = 1300;

// The min width derived from max values above
export const X_LARGE_MIN = LARGE_MAX + 0.001;
export const LARGE_MIN = MEDIUM_MAX + 0.001;
export const MEDIUM_MIN = TABLET_MAX + 0.001;
export const TABLET_MIN = SMALL_MAX + 0.001;
export const SMALL_MIN = MOBILE_MAX + 0.001;
